import React from 'react';
import { Icon, P } from '@contently/toolkit';
import styled from '@emotion/styled';

const PercentageIcon = styled(Icon)`
  color: ${props => props.color};
  font-weight: 500;
  &:before {
    content: none;
  }
`;

const ToolTipText = (styled('span'))`
  color: ${props => props.color};
`;

const Text = styled(P)`
  margin-right: 1rem;
`;

const benchmarkTooltipText = (type, percentage, value, positive, monthlyComparisonColor, pubComparisonColor, monthlyChangeDirection, lastFullMonthName) => {
  const angleIcon = positive ? 'angle-up' : 'angle-down';
  const pubComparisonDirection = positive ? 'higher' : 'lower';

  switch (type) {
    case "pubComparison":
      return (
        <span>
          Contently benchmark:
          <PercentageIcon color={pubComparisonColor} type={angleIcon}>
            {`${percentage}%`}
          </PercentageIcon>{' '}
          {pubComparisonDirection} compared to publications in the Contently network.
        </span>
      );
    case "monthlyComparison":
      return (
        <span>
          <ToolTipText color={monthlyComparisonColor}>
            {`${monthlyChangeDirection} ${percentage}% from ${value} in ${lastFullMonthName}`}
          </ToolTipText>
        </span>
      );
    default:
      return null;
  }
};

const benchmarkText = (type, percentage, value, monthlyComparisonColor, positive, monthlyChangeDirection) => {
  const benchmarkIcon = positive ? 'positive' : 'negative';
  
  switch (type) {
    case "pubComparison":
      return (
        <Text>
          <span className={`icon-benchmark icon-fixed-width ${benchmarkIcon}`} />
          {value}
        </Text>
      );
    case "monthlyComparison":
      return (
        <Text>
          <PercentageIcon color={monthlyComparisonColor} type={monthlyChangeDirection}>
            {percentage}%
          </PercentageIcon> from last month
        </Text>
      );
    default:
      return null;
  }
};

export {
  benchmarkTooltipText,
  benchmarkText
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/benchmarkHelper.jsx